import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, ChevronLeft } from "lucide-react";
import { useLanguage } from "../../../contexts/LanguageContext";
import useBurgerMenu from "../../../hooks/useBurgerMenu";
import "./Breadcrumb.css";

export default function Breadcrumb({ 
  items = [], 
  className = "",
  mobileOnly = false 
}) {
  const { lang } = useLanguage();
  const isRTL = lang === "ar";
  const hasBurgerMenu = useBurgerMenu();
  
  if (mobileOnly && !hasBurgerMenu) return null;
  
  const homeLabel = isRTL ? "الرئيسية" : "Home";
  
  const cleanItems = items.filter(item => {
    const label = (item.label || "").toLowerCase().trim();
    return label !== "home" && label !== "الرئيسية";
  });
  
  const finalItems = hasBurgerMenu
    ? [{ label: homeLabel, link: "/" }, ...cleanItems]
    : cleanItems;

  if (!finalItems || finalItems.length <= 1) return null;

  const SeparatorIcon = isRTL ? ChevronLeft : ChevronRight;

  const cleanLabel = (label) => {
    if (!label) return "";
    return label.replace(/\/+$/, "").trim();
  };

  return (
    <nav 
      className={`breadcrumb-wrapper ${className}`} 
      dir={isRTL ? "rtl" : "ltr"}
      aria-label="Breadcrumb"
    >
      <div className="breadcrumb-container">
        <ol className="breadcrumb-list">
          {finalItems.map((item, index) => {
            const isLast = index === finalItems.length - 1;
            const label = cleanLabel(item.label);
            
            return (
              <li 
                key={index} 
                className={`breadcrumb-item ${isLast ? "breadcrumb-active" : ""}`}
              >
                {index > 0 && (
                  <span className="breadcrumb-separator" aria-hidden="true">
                    <SeparatorIcon size={14} strokeWidth={1.5} />
                  </span>
                )}
                
                {isLast ? (
                  <span className="breadcrumb-current">
                    <span className="breadcrumb-text">{label}</span>
                  </span>
                ) : (
                  <Link 
                    to={item.link || "#"} 
                    className="breadcrumb-link"
                  >
                    <span className="breadcrumb-text">{label}</span>
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
}